import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Productos',
    href: '#productos'
  }, {
    name: 'Paquetes',
    href: '#paquetes'
  }, {
    name: 'Testimonios',
    href: '#testimonios'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <header className="w-full z-50 flex flex-col fixed top-0 left-0 right-0" data-id="element-141">
      {/* Top Announcement Bar */}
      <div className="bg-[#1B5E20] text-white text-center py-2.5 px-4 text-xs sm:text-sm font-medium tracking-wide" data-id="element-142">
        🚚 ENVÍO GRATIS en pedidos +$141 | ✅ Natural | Sin Azúcar | Sin Gluten
        | Sin GMO
      </div>

      {/* Logo Bar */}
      <div className={`bg-white transition-all duration-300 ${isScrolled ? 'shadow-md py-3' : 'py-5 border-b border-gray-100'}`} data-id="element-143">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-144">
          <div className="text-2xl sm:text-3xl font-serif font-bold text-[#1B5E20] tracking-tight" data-id="element-145">
            Elixir<span className="text-[#F9A825]" data-id="element-146">X</span>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-147">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-[#1A1A1A] hover:text-[#4CAF50] transition-colors font-medium text-sm tracking-wide" data-id="element-148">
                {link.name}
              </a>)}
            <a href="#paquetes" className="bg-[#4CAF50] hover:bg-[#1B5E20] text-white px-6 py-2.5 rounded-full font-semibold transition-all shadow-sm hover:shadow-md transform hover:-translate-y-0.5 text-sm" data-id="element-149">
              Ordenar Ahora
            </a>
          </nav>

          {/* Mobile toggle */}
          <div className="md:hidden flex items-center" data-id="element-150">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-[#1A1A1A]" data-id="element-151">
              {mobileMenuOpen ? <X size={28} data-id="element-152" /> : <Menu size={28} data-id="element-153" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-white shadow-xl border-t border-gray-100 py-4 px-4 flex flex-col space-y-4" data-id="element-154">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-[#1A1A1A] font-medium py-2 border-b border-gray-50" data-id="element-155">
              {link.name}
            </a>)}
          <a href="#paquetes" onClick={() => setMobileMenuOpen(false)} className="bg-[#4CAF50] text-white text-center px-6 py-3 rounded-full font-semibold mt-2" data-id="element-156">
            Ordenar Ahora
          </a>
        </div>}
    </header>;
}